module.exports = __webpack_public_path__ + "static/media/js-api-icon.0f352a3f.svg";